module.exports = __webpack_public_path__ + "static/images/icon-close.2424921b5c97bcab0f2b74eb3ac5e369.svg";